import React from 'react'
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { commas } from 'helpers'
import PrintLogo from 'assets/img/tss-logo-thermal-wide.png'
import QRCode from 'qrcode.react'
import TSSLogo from 'assets/img/tss-color.png'

const ThermalBOLEthanol = ({
  bolQR,
  totalVolume,
  total,
  componentRef,
  invInters,
  bolData: {
    bolId,
    tare_weight,
    processed_at,
    terminal,
    carrier,
    driver_name,
    trailer_number,
    truck_number,
    status,
    weighmaster_license,
    buyer,
    purchase_order_number,
    sand_type,
    job_name,
    destination_address,
    temperature,
    truck_load_id
  }
}) => {
  const bolDate = {
    date: new Date(Date.parse(processed_at)).toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit'
    }),
    time: new Date(Date.parse(processed_at)).toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    })
  }

  // Use actual scale weight (total is calculated from gross_weight differences in parent)
  const totalWeightLbs = total

  return (
    <div className="thermal preview-container" ref={componentRef}>
      <div className="title">
        <p>STRAIGHT BILL OF LADING</p>
        <p>SHORT FROM ORIGINAL - NOT NEGOTIABLE</p>
      </div>

      <div className="header">
        <img src={PrintLogo} alt="tss-print-logo" style={{ width: 50, height: 'auto' }} />
        <div className="bol-number">
          <div className="label">BOL #</div>
          <div>{bolId}</div>
        </div>
        <div className="date-time">
          <div>{bolDate.date}</div>
          <div className="time">{bolDate.time}</div>
        </div>
      </div>

      <div className="basic-info">
        <p>
          Terminal: <strong>{terminal}</strong>
        </p>
        <p>
          PO #: <strong>{purchase_order_number?.replace(/-/g, '\u2011')}</strong>
        </p>
        <p>
          Carrier: <strong>{carrier}</strong>
        </p>
        <p>
          Driver: <strong>{driver_name}</strong>
        </p>
        {truck_load_id && (
          <p>
            SandDrive Truck Load ID: <strong>{truck_load_id}</strong>
          </p>
        )}
        <p>
          Trailer #: <strong>{trailer_number}</strong>
        </p>
        <p>
          Truck #: <strong>{truck_number}</strong>
        </p>
        <p>
          Producer/Buyer: <strong>{buyer}</strong>
        </p>
        <p>
          Destination: <strong>{job_name}</strong>
        </p>
        {destination_address && (
          <p>
            Destination Address: <strong>{destination_address}</strong>
          </p>
        )}
        <p>
          Status: <strong>{status}</strong>
        </p>
        {temperature != null && temperature !== '' && (
          <p>
            Temperature: <strong>{temperature}&deg;F</strong>
          </p>
        )}
        <p>
          Product Type: <strong>{sand_type}</strong>
        </p>
      </div>

      <div className="qr-section">
        <QRCode
          value={JSON.stringify(bolQR)}
          size={240}
          className="qr-code"
          level="L"
          renderAs="svg"
          imageSettings={{
            src: TSSLogo,
            height: 30,
            width: 30,
            excavate: true
          }}
        />
      </div>
      <div className="legal-section">
        <p>
          Subject to Section 7 of conditions of applicable Bill of Lading. If this shipment is to be delivered to the
          consignee, without recourse on the consignor, the consignor shall sign the following statement. The carrier
          may decline to make delivery of this shipment without payment of freight and all other lawful charges. The
          property described below is in apparent good condition except as noted.
        </p>
        <p>
          <strong>WARNING: ETHANOL - FLAMMABLE LIQUID</strong>
        </p>
        <p>
          Contains denatured fuel ethanol. Highly flammable liquid and vapor. Keep away from heat, sparks, open flames,
          and hot surfaces. No smoking. Keep container tightly closed. Ground and bond container and receiving equipment.
          Use explosion-proof electrical, ventilating, and lighting equipment. Use only non-sparking tools.
          Take action to prevent static discharges. See Material Safety Data Sheet for detailed information.
        </p>
      </div>
      <div className="table-container">
        <Table size="small" className="thermal-table">
          <TableHead>
            <TableRow>
              <TableCell>Product Type</TableCell>
              <TableCell>Tank Car</TableCell>
              <TableCell align="right">Vol (gal)</TableCell>
              <TableCell align="right">Weight (lbs)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invInters.map((row, index) => {
              // For ethanol, use volume_reading to calculate dispensed gallons
              const volumeDispensed =
                index === 0
                  ? row.volume_reading || 0
                  : (row.volume_reading || 0) - (invInters[index - 1].volume_reading || 0)
              // Use actual scale weight instead of calculated estimate
              const shippingWeight =
                index === 0
                  ? row.gross_weight - tare_weight
                  : row.gross_weight - invInters[index - 1].gross_weight

              return (
                <TableRow key={row.inventory_id}>
                  <TableCell>{sand_type}</TableCell>
                  <TableCell>{row.inventory_id}</TableCell>
                  <TableCell align="right">{commas(volumeDispensed)}</TableCell>
                  <TableCell align="right">{commas(shippingWeight)}</TableCell>
                </TableRow>
              )
            })}
            <TableRow className="subtotal-row">
              <TableCell></TableCell>
              <TableCell>
                <strong>Sub Total</strong>
              </TableCell>
              <TableCell align="right">{commas(totalVolume)}</TableCell>
              <TableCell align="right">{commas(totalWeightLbs)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <strong>Tare</strong>
              </TableCell>
              <TableCell align="right">-</TableCell>
              <TableCell align="right">{commas(tare_weight)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <strong>Gross</strong>
              </TableCell>
              <TableCell align="right">-</TableCell>
              <TableCell align="right">{commas(tare_weight + totalWeightLbs)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <Grid container className="GridContainer">
        <Grid item xs={6} className="GridItem certification-text">
          <p>
            <strong>SHIPPER CERTIFICATION</strong>
          </p>
          <p>
            This is to certify that the above-named materials are properly classified, described, packaged, marked and
            labeled, and are in proper condition for transportation according to the applicable regulations of the
            Department of Transportation (DOT).
          </p>
        </Grid>
        <Grid item xs={6} className="GridItem certification-text">
          <p>
            <strong>CARRIER CERTIFICATION</strong>
          </p>
          <p>
            Carrier acknowledges receipt of material and packing in proper condition for shipment. Any damages and or
            defects in packaging and material not noted before shipment leaves Texas Speciality Sands facilities is the
            responsibility of the carrier. Carrier has reviewed BOL including but not limited to grade, PO, destination,
            and/or operator. Carrier acknowledges that the BOL is accurate
          </p>
        </Grid>
        <Grid item xs={6} className="GridItem">
          <div className="signature-box">{weighmaster_license}</div>
        </Grid>
        <Grid item xs={6} className="GridItem">
          <div className="signature-box">{driver_name}</div>
        </Grid>
        <Grid item xs={6} className="GridItem certification-text">
          <p>
            <strong>FREIGHT COLLECT</strong>
          </p>
          <p>
            If this shipment is to be delivered to the consignee, without recourse on the cosignor, the cosignor shall
            sign the following statement:
          </p>
        </Grid>
        <Grid item xs={6} className="GridItem certification-text">
          <p>
            <strong>ITEMS RECEIVED IN GOOD</strong>
          </p>
        </Grid>
        <Grid item xs={6} className="GridItem">
          <div style={{ borderBottom: '1px solid black', height: 50 }}></div>
          <p className="legal-text">Signature of Consignor</p>
        </Grid>
        <Grid item xs={6} className="GridItem">
          <div style={{ borderBottom: '1px solid black', height: 50 }}></div>
          <p className="legal-text">Signature of Consignor</p>
        </Grid>
      </Grid>
    </div>
  )
}

export default ThermalBOLEthanol
